import * as React from 'react';

const GetProFinanceSectionComponent: React.StatelessComponent = () => (
  <div>
    <div className="container">
      <div className="gap-50"/>
      <div className="row">
        <div className="col-md-8">
          <h4 className="f-w-100 invest-title">
            <strong>Consigue una ronda de financiación profesional a precios competitivos</strong>
          </h4>
          <div className="gap-5"/>
        </div>

        <p className="col-md-12 share-risk">
          <strong>Compartimos el riesgo contigo, no cobramos nada si la operación no se financia con éxito.
            Una vez acabada
          la operación, y sólo si se financia con éxito, te facturaremos nuestras comisiones.</strong>
        </p>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div
            className="simple-card-gray"
            style={{height: '313px'}}
          >
            <div className="gap-20"/>
            <div className="row title-card-gray">
              Comisión de estructuración
            </div>
            <div className="gap-50"/>
            <div className="gap-50"/>
            <div className="row fee-number-transp">
              6<a className="x-transp">%</a>
            </div>
            <div className="gap-30"/>
            <div className="gap-20"/>
            <div className="row fee-description">
              <strong>De la cantidad transaccionada</strong>
            </div>
            <div className="row fee-description">
              (IVA no incluido)
            </div>
            <div className="gap-30"/>

          </div>
        </div>

        <div className="col-md-6">
          <div
            className="simple-card-gray"
            style={{height: '313px'}}
          >
            <div className="gap-20"/>
            <div className="row title-card-gray">
              Comisión de seguimiento
            </div>
            <div className="gap-50"/>
            <div className="gap-50"/>
            <div className="row fee-number-transp">
              4.000<a className="x-transp">€</a>
            </div>
            <div className="gap-30"/>
            <div className="gap-20"/>
            <div className="row fee-description">
              <strong>Anuales</strong>
            </div>
            <div className="row fee-description">
              (IVA no incluido)
            </div>
            <div className="gap-30"/>

          </div>
        </div>

      </div>

      <div className="row">
        <div className="col-md-6">
          <div>
            <strong className="fee-description">El pago de esta comisión incluye:</strong>
            <div className="gap-10"/>
            <p className="text-left fe-desc">
              Análisis de la operación
              <br/><div className="gap-10"/>
              Soporte en la preparación de la documentación para inversores
              <br/><div className="gap-10"/>
              Asignación de un responsable de fundraising par asesorarte durante la campaña
              <br/><div className="gap-10"/>
              Acceso a nuestra red de inversores
              <br/><div className="gap-10"/>
              Plataforma de pagos
              <br/><div className="gap-10"/>
              Asignación de un responsable de Formalización de Operaciones para asesorarte en el cierre de la operación
              <br/><div className="gap-10"/>
              Pacto de Socios y Contrato de Sindicación estándar
            </p>
          </div>
        </div>

        <div className="col-md-6">
          <div>
            <strong className="fee-description">El pago de esta comisión incluye:</strong>
            <div className="gap-10"/>
            <p className="text-left fe-desc">
              Preparación de informes de seguimiento trimestrales
              <br/><div className="gap-10"/>
              Gestión de la comunicación entre el emprendedor y los inversores
              <br/><div className="gap-10"/>
              Administración de los inversores durante la fase de inversión y postinversión
              <br/><div className="gap-10"/>
              Asesoramiento al equipo emprendedor

            </p>
          </div>
        </div>

      </div>

    </div>

  </div>
);

export default GetProFinanceSectionComponent;



// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/GetProFinanceSection.component.tsx